import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RationsSupplierBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RATIONS_SUPPLIER;
}

export default RationsSupplierBuildingTileEntity;
